(function () {
  function init() {
    var select = document.querySelector('[data-venture-country-select]');
    if (!select) return;

    select.addEventListener('change', function () {
      var countryCode = select.value;
      select.disabled = true;
      fetch('/localization', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: 'country_code=' + encodeURIComponent(countryCode) + '&_method=put',
      }).then(function () {
        window.location.reload();
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
